import React from "react";
import { Link } from "react-router-dom";
import { ASSETS } from "@/lib/content";
import { mediaUrl } from "@/lib/api";

export const Logo = ({ className = "" }) => (
  <Link to="/" className={`inline-flex items-center ${className}`} data-testid="logo-link" aria-label="After Dark Chocolates home">
    <img
      src={mediaUrl(ASSETS.logo)}
      alt="After Dark Chocolates"
      draggable="false"
      className="h-16 sm:h-20 w-auto object-contain object-left select-none"
    />
  </Link>
);

export default Logo;
